export const statusLabels: Record<string, string> = {
    CHECK_PENDING: "Kontrol bekliyor",
    PHYSICAL_COUNT_PENDING: "Fiziki sayım bekliyor",
    MAIN_WAREHOUSE_CONFIRMATION_PENDING: "Depo teyidi bekliyor",
    STAGING_WAREHOUSE_CONFIRMATION_PENDING: "Cep depo teyidi bekliyor",
    TRANSFER_PREPARING: "Transfer hazırlanıyor",
    TRANSFER_COMPLETED: "Transfer tamamlandı",
    SYSTEM_VARIANCE_INVESTIGATING: "Sistemsel fark araştırılıyor",
    READY_FOR_PRODUCTION: "Üretime hazır",
    ESCALATION_REQUIRED: "Çözülemedi / eskalasyon gerekli",
    EXCEPTION_CLOSED: "İstisna ile kapatıldı",
};
export const readinessLabels: Record<string, string> = {
    READY: "Hazır",
    PREPARING: "Hazırlanıyor",
    CONFIRMATION_PENDING: "Teyit bekliyor",
    RISK: "Riskli",
    CRITICAL_SHORTAGE: "Kritik eksik",
    DATA_ERROR: "Veri hatası",
    UNRESOLVED: "Çözülemedi",
};
export const ownerLabels: Record<string, string> = {
    PLANNING: "Planlama",
    MAIN_WAREHOUSE: "Ana depo",
    HANDOFF_WAREHOUSE: "Teslim / tesellüm",
    STAGING_WAREHOUSE: "Cep depo",
    SYSTEM_ADMIN: "Sistem yöneticisi",
};
export const messageLabels: Record<string, string> = {
    MATERIAL_REQUEST: "Malzeme talebi",
    TRANSFER_REQUEST: "Transfer ihtiyacı",
    CONFIRMATION_REQUEST: "Teyit isteği",
    COMMENT: "Açıklama",
};
export const historyLabels: Record<string, string> = {
    CHECK_CREATED: "Otomatik kontrol oluşturuldu",
    RECIPE_CHANGED: "Reçete değişikliği algılandı",
    TASK_CREATED: "Hazırlık görevi oluşturuldu",
    TASK_ASSIGNED: "Görev atandı",
    TASK_STATUS_CHANGED: "Görev durumu değişti",
    TASK_UNLOCKED: "Sonraki rota adımı açıldı",
    TASK_RECONCILED: "Görev stok ve teyitle uzlaştırıldı",
    TASK_SUPERSEDED: "Görev yeni revizyonla geçersiz oldu",
    TASK_EXCEPTION_CLOSED: "Görev istisna ile kapatıldı",
    PHYSICAL_COUNT_RECORDED: "Fiziki sayım kaydedildi",
    WORKFLOW_MESSAGE_ADDED: "Depo iletişimi eklendi",
    STATUS_CHANGED: "Kontrol durumu değişti",
    STATUS_OVERRIDDEN: "Gerekçeli istisna verildi",
    TASK_ESCALATED: "Sahiplenilmeyen görev eskale edildi",
    CRITICAL_LEAD_ESCALATED: "Üretim öncesi kritik süre eskalasyonu",
};
export const historyStatusLabels: Record<string, string> = {
    ...statusLabels,
    AUTO_CREATED: "Otomatik oluşturuldu",
    WAREHOUSE_PENDING: "Depo işlemi bekliyor",
    PICKING: "Toplanıyor",
    PARTIALLY_PREPARED: "Kısmi hazırlandı",
    READY_FOR_TRANSFER: "Transfer için hazır",
    DISPATCHED: "Cep depoya sevk edildi",
    STAGING_CONFIRMATION_PENDING: "Cep depo teyidi bekliyor",
    PHYSICAL_CONFIRMED: "Fiziki teyit tamamlandı",
    READY: "Üretime hazır",
    STOCK_SHORTAGE: "Eksik stok",
    SYSTEM_PHYSICAL_VARIANCE: "Fiziki-sistemsel fark",
    WRONG_LOCATION: "Yanlış lokasyon / malzeme",
    INVALID_MATERIAL: "Reçete veya birim verisi hatalı",
    BLOCKED: "Engellendi",
    UNRESOLVED: "Çözülemedi",
    SUPERSEDED: "Yeni revizyonla geçersiz",
};
export function historyStateSummary(value: unknown) {
    if (!value || typeof value !== "object" || Array.isArray(value))
        return null;
    const state = value as Record<string, unknown>;
    const parts: string[] = [];
    const status = typeof state.status === "string"
        ? state.status
        : typeof state.taskStatus === "string"
            ? state.taskStatus
            : null;
    if (status)
        parts.push(historyStatusLabels[status] ?? status);
    if (typeof state.materialCode === "string")
        parts.push(`Malzeme ${state.materialCode}`);
    if (typeof state.scope === "string")
        parts.push(`Kapsam ${state.scope === "MAIN" ? "ana depo" : state.scope === "HANDOFF" ? "teslim / tesellüm" : state.scope === "STAGING" ? "cep depo" : state.scope}`);
    if (typeof state.quantity === "number")
        parts.push(`Fiziki miktar ${state.quantity}`);
    if (typeof state.systemQuantityAtCount === "number")
        parts.push(`Sistem miktarı ${state.systemQuantityAtCount}`);
    if (typeof state.preparedQuantity === "number")
        parts.push(`Hazırlanan ${state.preparedQuantity}`);
    if (typeof state.receivedQuantity === "number")
        parts.push(`Teslim alınan ${state.receivedQuantity}`);
    if (typeof state.assignedToName === "string")
        parts.push(`Sorumlu ${state.assignedToName}`);
    if (typeof state.type === "string")
        parts.push(messageLabels[state.type] ?? state.type);
    if (typeof state.requestedQuantity === "number")
        parts.push(`Talep ${qty(state.requestedQuantity, typeof state.unit === "string" ? state.unit : "")}`);
    if (typeof state.version === "number")
        parts.push(`Sürüm ${state.version}`);
    return parts.length ? parts.join(" · ") : null;
}
export const qty = (value: number | null, unit: string) => value === null
    ? "—"
    : `${new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 3 }).format(value)} ${unit}`;
